import { render, staticRenderFns } from "./noticePhone.vue?vue&type=template&id=2b68bcde&scoped=true&"
import script from "./noticePhone.vue?vue&type=script&lang=js&"
export * from "./noticePhone.vue?vue&type=script&lang=js&"
import style0 from "./noticePhone.vue?vue&type=style&index=0&id=2b68bcde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b68bcde",
  null
  
)

export default component.exports